const ScopeComponent = (Component) => {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"36c20f3"}`, "");
  });
};
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-Dw8Duyxn.mjs.map
